<ui-page [testHook]="testHooks.Page">
	<div [uiColSpan]="12">
		<ui-content-header
			title="Documents"
			type="page"
			[testHook]="testHooks.DocumentsContentHeader"
		>
			<ui-button
				title-action
				label="Add"
				(click)="openDocumentsDrawer()"
				data-intercom-target="documents-packages-page-add-button"
				[testHook]="testHooks.AddButton"
			></ui-button>
		</ui-content-header>
		<ui-tabs
			queryParamKey="tab"
			storageKey="documents-v2-tab"
			[testHook]="testHooks.Tabs"
		>
			<ui-tab id="packages" title="Packages" [testHook]="testHooks.PackagesTab">
				<div post-title class="text-green-600 text-xs">New!</div>
				<app-matter-packages />
			</ui-tab>
			<ui-tab
				id="my-documents"
				title="My Documents"
				[testHook]="testHooks.MyDocumentsTab"
			>
				<app-word-documents />
			</ui-tab>
		</ui-tabs>
	</div>
</ui-page>

<ng-template #noDocuments>
	<div
		[uiColSpan]="12"
		class="flex flex-col gap-y-4 bg-white rounded-lg px-8 pt-20"
	>
		<div class="w-40 mx-auto">
			<img
				src="/assets/images/undraw/undraw_add-files.svg"
				alt="No documents found"
			/>
		</div>
		<div class="text-center flex flex-col gap-y-1 pb-20">
			<h5 class="h5">No documents added yet!</h5>
			<p class="p-sm text-gray-500">
				Click add to start building your document list for this matter.
			</p>
		</div>
	</div>
</ng-template>
